export enum TirPmDropdownVariantEnum {
  Contained = 'Contained',
  Detached = 'Detached',
}
